<template>
  <b-modal :id="id" ref="deny" :cancel-title="$t('_cancel')" @ok="confirm" @cancel="cancel">
    <text-area-input name="deny-reasons" v-model="submitterInfos.values.comment"
                     :label="$t(question)" :placeholder="$t('booking.deny.placeholder')"
                     :required="false"
    />
  </b-modal>
</template>

<script>
import textAreaInput from '@/components/frontoffice/form/baseInput/textArea'
import modalMixin from '@/components/frontoffice/Booking/modal/mixin'
import { status } from '@/utils/bookingStatus'

export default {
  name: 'booking-modal-deny',

  components: {
    textAreaInput
  },

  mixins: [modalMixin],

  props: {
    id: {
      type: String,
      default: "deny"
    },
    bookingStatus: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      submitterInfos: {
        type: 'booking_deny',
        values: {
          comment: null,
          isUnlogged: this.isUnlogged
        }
      }
    }
  },

  computed: {
    question () {
      let action = this.bookingStatus === status.WAITING_FOR_MANAGER_PRE_VALIDATION ? 'prevalidation' : 'postvalidation'

      return 'booking.deny.' + action + '.question'
    },

    successMessage () {
      let action = this.bookingStatus === status.WAITING_FOR_MANAGER_PRE_VALIDATION ? 'prevalidation' : 'postvalidation'

      return 'booking.deny.' + action + '.validation'
    }
  }
}
</script>
